<div class="chart-container">
    <canvas #chartCanvas class="graph" [id]="canvasId"></canvas>
    <app-tooltip [title]="tooltipTitle" [data]="tooltipValues" [tooltipId]="tooltipId"></app-tooltip>
</div>
